<template>
  <div>
    <CardedForm
      ref="sub_categories_form_ref"
      id="sub_categories_form"
      title="_"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
    >
      <SelectField
        v-model="form.category_id"
        :options="categories"
        :small_chips="false"
        :validation_rules="form_rules.category_id"
        label="Parent Category"
        icon="mdi-pen-plus"
        :disabled="is_loading || is_from_category"
        item_text="name"
        item_value="id"
      ></SelectField>
      <TextField
        v-model="form.name"
        :validation_rules="form_rules.name"
        label="Name of Sub Category"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>
      <TextField
        v-model="form.description"
        :validation_rules="form_rules.description"
        label="Description"
        icon="mdi-pen-plus"
        :disabled="is_loading"
      ></TextField>
      <v-row no-gutters>
        <v-col no-gutters class="pr-2">
          <TextField
            v-model="form.icon"
            :validation_rules="form_rules.icon"
            label="Small Icon"
            icon="mdi-pen-plus"
            :disabled="is_loading"
          ></TextField>
        </v-col>
        <v-col no-gutters class="pl-2">
          <ImageField
            label="Thumbnail Picture"
            icon="mdi-camera"
            :disabled="is_loading"
            folder="categories"
            @on-hide-loader="hide_loader"
            @on-show-loader="show_loader"
            @on-success="on_finished_file_upload"
            @on-error="on_file_upload_errors"
            ref="subcat_file_uploader"
            :required="false"
            empty_file_error="No thumbnail image choosen for the sub category"
            :default_value="default_thumbnail"
          >
          </ImageField>
        </v-col>
      </v-row>
    </CardedForm>
  </div>
</template>

<script>
import CardedForm from "../../../components/CardedForm";
import TextField from "../../../components/TextField";
import ImageField from "../../../components/ImageField";
import SelectField from "../../../components/SelectField";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminCategoriesAddSubCategory",
  components: {
    CardedForm,
    TextField,
    ImageField,
    SelectField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_editing: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      errors: [],
      message: "",
      form: {
        category_id: 0,
        name: "",
        description: "",
        icon: "",
        thumb_nail: "",
      },
      form_rules: {
        category_id: [
          Utils.validate.is_required("Parent Category must be provided"),
        ],
        name: [
          Utils.validate.is_required("Sub Category name is required"),
          Utils.validate.min_max_length(
            3,
            30,
            "Sub Category name should be between 3 and 30 characters "
          ),
        ],
        description: [
          Utils.validate.max_length(
            60,
            "Description should be less than 60 characters"
          ),
        ],
        icon: [
          Utils.validate.is_required("Icon Is required"),
          Utils.validate.min_max_length(
            3,
            20,
            "Icon name should be between 3 and 20 characters "
          ),
        ],
        thumb_nail: [],
      },
      default_thumbnail: Utils.get_default_category().thumbnail,
      default_icon: Utils.get_default_category().icon,
      is_from_category: false,
      categories: [],
      edit_sub_category_id: 0,
    };
  },
  methods: {
    fill_edit_category(sub_category) {
      console.log("Sub category to be edited ", sub_category);
      this.edit_sub_category_id = sub_category.id;
      this.is_from_category = false;
      this.form.category_id = parseInt(sub_category.category_id);
      this.form.name = sub_category.name;
      this.form.description = sub_category.description;
      this.form.icon = sub_category.icon;
      this.form.thumb_nail = sub_category.thumb_nail;
      this.default_thumbnail = sub_category.thumb_nail;
      this.default_icon = sub_category.icon;
      this.errors = [];
      this.message = "";
      this.load_categories();
    },
    on_auto_fill() {
      var rnd = Math.ceil(Math.random() * 456);
      (this.form.category_id =
        this.categories.length > 0 ? this.categories[0].id : 0),
        (this.form.name = "Sub_Category_" + rnd);
      this.form.description = rnd + " This is a nice sub category description ";
      this.form.icon = this.default_icon;
      this.form.thumb_nail = this.default_thumbnail;
      this.errors = [];
      this.message = "";
    },
    init_form() {
      this.is_from_category = false;
      this.form.category_id = 0;
      if (this.$route.params.id) {
        this.is_from_category = true;
        this.form.category_id = parseInt(this.$route.params.id);
      }
      this.form.name = "";
      this.form.description = "";
      this.form.icon = this.default_icon;
      this.form.thumb_nail = this.default_thumbnail;
      this.errors = [];
      this.message = "";
    },
    hide_loader() {
      this.$emit("on-hide-loader");
    },
    show_loader() {
      this.$emit("on-show-loader");
    },
    on_file_upload_errors(errors) {
      this.errors = errors;
      this.$refs.sub_categories_form_ref.show_error_dialog();
    },
    on_hide_message() {
      if (this.is_editing) {
        this.$emit("on-success-edit");
      }else{
        this.init_form();
      }
    },
    submit() {
      this.$refs.subcat_file_uploader.upload_file();
    },
    on_finished_file_upload(file_url) {
      this.form.thumb_nail = file_url;
      if (this.is_editing) {
        this.update_sub_category();
      } else {
        this.post_sub_category();
      }
    },
    post_sub_category() {
      //form is already validated
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Categories.post_sub_category(
        {
          ...this.form,
        },
        (res) => {
          console.log("add sub category res", res);
          this.$refs.sub_categories_form_ref.on_clear_form();
          this.init_form();
          this.$emit("on-hide-loader");
          this.message =
            "<b>Operation was successfull</b> <br/>  New Sub Category was added successfully";
          this.$refs.sub_categories_form_ref.show_message_dialog();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.sub_categories_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
    update_sub_category() {
      this.$emit("on-show-loader");
      ServerClient.Categories.update_sub_category(
        {
          id: this.edit_sub_category_id,
          ... this.form
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.message = "<b>Update Operation Was Successfull</b> <br/>  Sub Category was edited successfully";
          this.$refs.sub_categories_form_ref.show_message_dialog();
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.errors = errors;
          this.$refs.sub_categories_form_ref.show_error_dialog();
        }
      );
    },
    load_categories() {
      this.$emit("on-show-loader");
      ServerClient.Categories.get_categories(
        {
          is_drop_down: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.categories = res;
          if (this.is_editing == false) {
            this.init_form(); //re initialisr form
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading categories on admin add sub category form"
          );
        }
      );
    },
  },
  mounted() {
    if (this.is_editing == false) {
      this.init_form();
      var crumps = [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Sub Categories",
          disabled: false,
          href: "/admin/categories/sub_categories/list",
        },
        {
          text: "List",
          disabled: false,
          href: "/admin/categories/sub_categories/list",
        },
        {
          text: "New",
          disabled: true,
          href: "/admin/categories/sub_categories/add",
        },
      ];
      var title = "Add Sub Category";
      if (this.is_from_category == true) {
        title = "Add Sub Category To Category";
        crumps = [
          {
            text: "Admin",
            disabled: false,
            href: "/admin",
          },
          {
            text: "Categories",
            disabled: false,
            href: "/admin/categories",
          },
          {
            text: "List",
            disabled: false,
            href: "/admin/categories/list",
          },
          {
            text: "View",
            disabled: false,
            href: "/admin/categories/view/" + this.form.category_id,
          },
          {
            text: "Sub",
            disabled: true,
            href:
              "/admin/categories/view/" +
              this.form.category_id +
              "/add/subcategory",
          },
        ];
      }

      this.$emit("set-page-attributes", {
        title: title,
        crumps: crumps,
      });

      this.load_categories();
    }
  },
};
</script>